import React, { useState, useContext, useEffect } from 'react';
import MaterialTable from 'material-table';
import tableIcons from "./components/MaterialTableIcons";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import ARPaymentID from './ARPaymentID';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios';
import { api_url } from "./authorize";
import { AuthorizeContext } from './RootContext';

const tableStyles = makeStyles({
  root: { justifyContent: 'space-evenly' },
  spacing: { justifyContent: 'space-evenly' },
});

const useStyles = makeStyles({
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
  },
  title: {
    fontSize: '2em',
  },
});

const theme = createTheme({
  typography: { h6: { fontSize: '1.4em' } },
});

const numberWithCommas = (x) => {
  if (x === null || x === undefined || x === "") return "0.00";
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
};

const getAccountNumber = (rowData) => {
  return (
    rowData?.Acct_No ||
    rowData?.Acct_No_ ||
    rowData?.AcctNo ||
    rowData?.acctNo ||
    rowData?.acctid ||
    rowData?.Acct_ID ||
    rowData?.account ||
    rowData?.Account_No ||
    ""
  );
};

const ARPay = () => {
  const tableClass = tableStyles();
  const classes = useStyles();

  const { token, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);

  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const [chosen, setChosen] = useState({});
  const [tableData, setTableData] = useState([]);

  const history = useHistory();

  const handleClickOpen = (chosenRow) => () => {
    setOpen(true);
    console.log(chosenRow);
    setChosen(chosenRow || {});
  };

  const goBack = () => {
    history.push('/accounthome');
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
    window.location.reload();
  };

  useEffect(() => {
    const fetchData = async () => {
      axios({
        url: `https://${api_url}/api/packing_invoice?lookup=Payment`,
        method: 'get',
        headers: {
          'x-access-token': token,
        },
      }).then((res) => {
        if (res.data.message) {
          alert(res.data.message);
        } else if (res.data.validation) {
          alert(res.data.validation.replace("_", " "));
        } else if (res.data.notLoggedIn) {
          setAuthenticated(false);
          setAuthBody({ role: 'visitor' });
          alert("You have been logged out due to inactivity. Please log in again.");
        } else {
          setTableData(Array.isArray(res.data) ? res.data : []);
          console.log(res.data);
        }
      }).catch((error) => {
        console.error("Failed to load AR payments:", error);
        alert("Failed to load AR payments.");
      });
    };

    fetchData();
  }, [token, setAuthenticated, setAuthBody]);

  const columns = [
    {
      title: 'PaymentID',
      field: 'Payment_ID',
      editable: "never",
      render: rowData => {
        return (
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickOpen(rowData)}
            >
              {rowData.Payment_ID}
            </Button>
          </div>
        );
      },
      cellStyle: { fontSize: '1em' },
    },
    {
      title: 'Date',
      field: 'Paid_Date',
      editable: "never",
      cellStyle: { fontSize: '1em' },
    },
    {
      title: 'Account#',
      field: 'Acct_No',
      editable: "never",
      cellStyle: { fontSize: '1em' },
      render: rowData => {
        return (
          <div>
            {getAccountNumber(rowData)}
          </div>
        );
      },
    },
    {
      title: 'Distributor Name',
      field: 'Customer_Name',
      editable: "never",
      cellStyle: { fontSize: '1em' },
    },
    {
      title: 'Currency',
      field: 'currency',
      editable: "never",
      cellStyle: { fontSize: '1em' },
    },
    {
      title: 'AMT',
      field: 'Total',
      editable: "never",
      cellStyle: { fontSize: '1em' },
      filtering: false,
      render: rowData => {
        return (
          <div style={{ textAlign: 'left' }}>
            {numberWithCommas(Number.parseFloat(rowData.Total || 0).toFixed(2))}
          </div>
        );
      },
    },
    {
      title: 'Reference#',
      field: 'ref',
      editable: "never",
      cellStyle: { fontSize: '1em' },
      filtering: false,
      render: rowData => {
        return (
          <div>
            {rowData.ref || rowData.reference || rowData.Reference || ""}
          </div>
        );
      },
    },
  ];

  return (
    <div className="ARPayment">
      <h1 align="center">Account Receivable Payment</h1>

      <button onClick={goBack}>
        Back
      </button>

      <ThemeProvider theme={theme}>
        <MaterialTable
          title="*Accounts Receivable Payments"
          icons={tableIcons}
          columns={columns}
          data={tableData}
          actions={[
            {
              icon: tableIcons.Add,
              tooltip: 'Add User',
              isFreeAction: true,
              onClick: () => {
                history.push('./ReceivedForm');
              },
            },
          ]}
          onSelectionChange={(selectedRows) => setSelectedRows(selectedRows)}
          options={{
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "outlined",
            filtering: false,
            paging: true,
            pageSizeOptions: [2, 5, 10, 15, 50],
            pageSize: 5,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: {
              csv: true,
            },
            exportAllData: true,
            exportFileName: "TableData",
            addRowPosition: "first",
            actionsColumnIndex: -1,
            selection: false,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            grouping: false,
            columnsButton: true,
            rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
            headerStyle: { background: "lightgray", fontStyle: "italic", fontSize: 19 },
            selectionProps: rowData => ({
              disabled: rowData.tax == null,
              color: "primary",
            }),
          }}
        />
      </ThemeProvider>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullScreen
        aria-labelledby="form-dialog-title"
        width={900}
        height={300}
        color="primary"
      >
        <DialogTitle id="form-dialog-title">
          {/* Payment ID Detail */}
        </DialogTitle>

        <DialogContent>
          <div>
            <ARPaymentID
              data={chosen.Invoice_List || []}
              name={chosen.Customer_Name || ""}
              id={chosen.Payment_ID || ""}
              sum={chosen.Total || 0}
              currency={chosen.currency || ""}
            />
          </div>

          <DialogActions
            disableSpacing
            classes={{
              root: tableClass.root,
              spacing: tableClass.spacing,
            }}
          >
            <button
              className="btn btn-primary"
              onClick={handleClose}
              style={{ fontSize: '2em' }}
            >
              Close
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ARPay;